/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pagination[_ngcontent-%COMP%]    > li[_ngcontent-%COMP%] {\n  cursor: pointer; }\n\n.news-header[_ngcontent-%COMP%] {\n  color: #6088D8; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/all-news/all-news.component.scss.shim.ngstyle.js.pre-build-optimizer.js